import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import Layout from '@adv-mt/mt-layout-basic'

import {useLandingInstantOfferTracking} from '../../../useLandingInstantOfferTracking.js'
import HeaderStep from '../../HeaderStep/index.js'
import CardVehicleSpecs from './components/CardVehicleSpecs/index.js'
import ListVehicleOptions from './components/ListVehicleOptions/index.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-StepVehicleSelect'

const fieldsToCheck = [
  'make',
  'bodyType',
  'doors',
  'fuelType',
  'fuelTypeId',
  'model',
  'transmissionType',
  'transmissionTypeId',
  'version',
  'plateRegistrationYear'
]

const LandingInstantOfferStepVehicleSelect = ({
  onClickConfirmVehicle,
  onClickEditVehicleData,
  onClickNotSellerVehicle,
  sellerVehicle,
  vehicleList = []
}) => {
  const {i18n} = useContext(Context)
  const {pageTrackVehicleSelectStep} = useLandingInstantOfferTracking()

  const commonData = {}
  const unCommonData = {}
  const [isLoading, setIsLoading] = useState(false)

  useMount(() => {
    pageTrackVehicleSelectStep({searchResultsCount: vehicleList.length})
  })

  fieldsToCheck.forEach(field => {
    const isTheFieldCommonInEveryVehicle = vehicleList.every(vehicle => vehicle[field] === vehicleList[0][field])
    if (isTheFieldCommonInEveryVehicle) {
      commonData[field] = vehicleList[0][field]
      return
    }
    unCommonData[field] = true
  })

  const vehicleSpecsTitle = `${commonData.make} ${commonData.model || ''}`

  const isOnlyOneVehicleOption = vehicleList.length === 1

  const handleClickEditData = () => {
    setIsLoading(true)
    onClickEditVehicleData({vehicle: vehicleList[0]})
  }

  const handleClickNotMyVehicle = () => {
    setIsLoading(true)
    onClickNotSellerVehicle()
  }

  const handleClickConfirmVehicle = ({vehicle}) => {
    onClickConfirmVehicle({vehicle: isOnlyOneVehicleOption ? vehicleList[0] : vehicle})
  }

  return (
    <>
      <Layout.Container isFullWidth>
        <main className={BASE_CLASS_NAME}>
          <HeaderStep pretitle={'Véndelo a un profesional'} title={'Datos del vehículo'} />
          <CardVehicleSpecs
            areEditableSpecs={isOnlyOneVehicleOption}
            title={vehicleSpecsTitle}
            vehicleData={{plate: sellerVehicle.plate, km: sellerVehicle.km, ...commonData}}
            {...(isOnlyOneVehicleOption && {onClickEditData: handleClickEditData})}
          />
          {!isOnlyOneVehicleOption && (
            <ListVehicleOptions
              onClickCard={handleClickConfirmVehicle}
              unCommonData={unCommonData}
              vehicleList={vehicleList}
            />
          )}
          <div className={`${BASE_CLASS_NAME}Buttons`}>
            {isOnlyOneVehicleOption ? (
              <div className={`${BASE_CLASS_NAME}ButtonsOneVehicleOption`}>
                <div>
                  <AtomButton
                    design={atomButtonDesigns.LINK}
                    fullWidth
                    isLoading={isLoading}
                    onClick={handleClickNotMyVehicle}
                    shape={atomButtonShapes.CIRCULAR}
                    size={atomButtonSizes.LARGE}
                  >
                    {`No es mi vehículo`}
                  </AtomButton>
                </div>
                <div>
                  <AtomButton
                    fullWidth
                    isLoading={isLoading}
                    onClick={handleClickConfirmVehicle}
                    shape={atomButtonShapes.CIRCULAR}
                    size={atomButtonSizes.LARGE}
                  >
                    {i18n.t(`COMMON.CONTINUE`)}
                  </AtomButton>
                </div>
              </div>
            ) : (
              <AtomButton
                design={atomButtonDesigns.LINK}
                isLoading={isLoading}
                onClick={handleClickNotMyVehicle}
                shape={atomButtonShapes.CIRCULAR}
                size={atomButtonSizes.LARGE}
              >
                {`Mi vehículo no sale en la lista`}
              </AtomButton>
            )}
          </div>
        </main>
      </Layout.Container>
    </>
  )
}

LandingInstantOfferStepVehicleSelect.displayName = 'LandingInstantOfferStepVehicleSelect'

LandingInstantOfferStepVehicleSelect.propTypes = {
  onClickConfirmVehicle: PropTypes.func,
  onClickEditVehicleData: PropTypes.func,
  onClickNotSellerVehicle: PropTypes.func,
  sellerVehicle: PropTypes.shape({km: PropTypes.string.isRequired, plate: PropTypes.string.isRequired}).isRequired,
  vehicleList: PropTypes.array.isRequired
}

export default LandingInstantOfferStepVehicleSelect
